import { styled } from "@mui/material";
import { Button } from "@mui/material";
import BottomShadow from "../icons/bottom-shadow.svg";
import TopShadow from "../icons/top-shadow.svg";

export const HeaderContainer = styled("header")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.1vw 5vw  0.1vw 0.3vw;
  background-color: white;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  height: 8.301vw;
  @media (max-width: 1280px) {
    padding: 0.6vw 3vw 0.6vw 0.5vw;  
    height: auto;  
  },
  @media (max-width: 768px) {
    padding: 1vw 3vw 1vw 0.5vw;  
    height: auto;  
  }
`;

export const LogoContainer = styled("div")`
  display: flex;
  align-items: center;
`;

export const LogoImage = styled("img")`
  width: 12vw;
  height: 8vw;
  cursor: pointer;
  @media (max-width: 1280px) {
    width: 10vw;  
    height: 6vw;  
  }
  @media (max-width: 768px) {
    width: 25vw;  
    height: 15vw;  
  }
`;

export const NavMenu = styled("nav")`
  display: flex;
  gap: 2vw;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const NavItem = styled("a")`
  text-decoration: none;
  color: #000;
  font-size: 1.377rem;/*22.04px */
  font-weight: 400;
  font-family: Radikal;
  cursor: pointer;
  @media (max-width: 1280px) {
    font-size: 1.2rem;
  }
  @media (max-width: 768px) {
    font-size: 1rem;
  }
  @media (max-width: 375px) {
    font-size:0.750rem;//12px
  }
`;

export const ButtonContainer = styled("div")`
  display: flex;
  align-items: center;
  gap: 1vw;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const StyledButton = styled(Button)`
  background-color: #1D00C4 !important;
  color: white !important;
  font-size: 1.382rem;/*22.11px*/
  padding: 0.688rem 2.5rem ;/*11px 40px*/ */
  font-weight: 400;
  font-family: Radikal;
  border-radius:0px !important;
  text-transform: none !important;
  @media (max-width: 1280px) {
    font-size: 1rem;/*22.11px*/
    padding: 0.4rem 1.8rem ;
  }
`;

export const MobileMenuIcon = styled("img")`
  width: 6vw;
  cursor: pointer;
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

export const MobileDrawer = styled("div")`
  position: fixed;
  top: 0;
  right: ${({ open }) => (open ? "0" : "-100%")};
  width: 100%;
  height: 100vh;
  background: white;
  transition: right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 5vw;
  z-index: 100;

  /* Top Shadow */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 36px;
    background: url(${TopShadow}) no-repeat center top;
    background-size: cover;
    pointer-events: none;
  }

  /* Bottom Shadow */
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 36px;
    background: url(${BottomShadow}) no-repeat center bottom;
    background-size: cover;
    pointer-events: none;
  }
`;

export const CloseButton = styled("img")`
  width: 5vw;
  position: absolute;
  top: 2vw;
  right: 4vw;
  cursor: pointer;
`;

export const MobileNavLinks = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5vw;
  width: 100%; 
  margin-top:10vw;
`;

export const MobileStyledButton = styled(Button)`
  background-color: #2400ff !important;
  color: white !important;
  font-size: 0.750rem;//12px
  padding: 0.364rem 1.875rem !important;// 5.82px 30px
  font-weight: bold !important;
  text-transform: none !important;
  border-radius: 0px !important;
`;

export const MobileLogoImage = styled("img")`
  width: 40%;
  margin-bottom: 5vw; 
  
  @media (max-width: 768px) {
    width: 50%; 
    margin-bottom: 2vw; 

  }
`;